<template>
  <span class="dropdown-container">
    <span @click="toggle">
      <slot name="button">
        <hcc-button>{{ buttonName }}</hcc-button></slot
      >
    </span>
    <transition :name="getAnimationName()">
      <ul
        v-if="showList"
        class="dropdown"
        :class="[customClass, position, { custom }]"
        @click="toggle"
        v-click-outside="toggle"
        style="animation-duration: 0.5s"
      >
        <slot/>
      </ul>
    </transition>
  </span>
</template>
<script>
import vClickOutside from 'v-click-outside';
import HccButton from '@/components/shared/HccButton/index.vue';

export default {
  components: {
    HccButton,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      showList: false,
    };
  },
  props: {
    buttonName: {
      type: String,
      default: 'Dropdown',
    },
    position: {
      type: String,
      default: 'bottom-right',
    },
    custom: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: [String, Array, Object],
    },
    dropdownRef: {
      type: String,
    },
  },
  methods: {
    toggle() {
      this.showList = !this.showList;
    },
    getAnimationName() {
      let name = '';

      if (this.position === 'bottom-left' || this.position === 'bottom' || this.position === 'bottom-right') {
        name = 'fadeDown';
      } else if (this.position === 'top-left' || this.position === 'top' || this.position === 'top-right') {
        name = 'fadeUp';
      } else if (this.position === 'right') {
        name = 'fadeRight';
      } else {
        name = 'fadeLeft';
      }

      return name;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~styles/shared/dropdown.scss";
</style>
